<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Über uns</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Startseite</a></li>
                        <li>Über uns</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape hidden md:block">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape" /></div>
    </div>
</div>

<!-- Über uns Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <div class="container py-5">
            <div class="section-title">
                <h2>Über Tommys</h2>
                <div class="bar"></div>
                <p>Dein schneller Weg zum Führerschein – persönlich, modern und ohne lange Wartezeiten. Willkommen bei Tommys Fahrschule in Gießen!</p>
            </div>

            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="about-content">
                        <h3>Deine Ausbildung, dein Tempo – wir machen’s möglich!</h3>
                        <div class="bar"></div>
                        <p>Mit unserem jungen und engagierten Team bieten wir dir eine flexible, praxisnahe und stressfreie Ausbildung. Theorie in nur 7 Tagen? Kein Problem!</p>
                        <p>Unsere modernen Fahrzeuge, top Fahrlehrer und individuelle Betreuung sorgen dafür, dass du optimal vorbereitet in die Prüfung gehst – und sicher auf die Straße.</p>
                        <div class="about-btn">
                            <a routerLink="/kontakt" class="default-btn">Jetzt starten <span></span></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-image">
                        <img src="assets/img/about.png" alt="image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-subscribe></app-subscribe>
